import { jsxs as l, jsx as u } from "react/jsx-runtime";
import { forwardRef as x, useRef as b, useEffect as d } from "react";
import { useTracking as j } from "../utils.js";
import v from "../builders-icons/dist/symbols/damage.js";
import y from "../builders-icons/dist/symbols/completion.js";
import R from "../builders-icons/dist/symbols/call-back.js";
import S from "../builders-icons/dist/symbols/analysis.js";
import $ from "clsx";
import s from "./status.module.css.js";
const h = {
  404: S,
  500: v,
  callback: R,
  completion: y
}, w = x(function({
  className: c,
  children: m,
  size: f = "lg",
  tracking: t = !1,
  variant: e = 404,
  ...i
}, n) {
  const o = b(!1), p = typeof t == "object" && !!t.eventLabel, r = j(p && t), a = h[`${e}`];
  return d(() => {
    !o.current && (o.current = !0) && r({
      eventCategory: `status_${e}`,
      eventAction: "impression"
    });
  }, [o, r, e]), /* @__PURE__ */ l(
    "section",
    {
      className: $(s.status, s[f], c),
      ref: n,
      ...i,
      children: [
        /* @__PURE__ */ u(a, { preserveAspectRatio: "xMaxYMin meet" }),
        m
      ]
    }
  );
});
export {
  w as Status
};
//# sourceMappingURL=status.js.map
